import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { icons } from '@assets/icons';

export const DetailTableStyle = css`
  tr {
    height: 50px;

    td {
      padding: 10px 30px;
    }
  }
`;

export const DetailButtonsSection = styled.section`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 412px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2px;
    & > button,
    & > section {
      margin: 5px;
    }
  }
`;

export const RightButtonSection = styled.section`
  display: flex;
  flex-direction: row;
`;

export const DeleteAccountButtonCss = css`
  width: 173px;
  height: 48px;
  font-size: 14px;
  border-color: #ff4c4c;
  color: #ff4c4c;
  :hover {
    background: #ffe8eb;
  }
  ::before {
    content: '';
    width: 12px;
    height: 12px;
    margin-right: 12px;
    background: url(${icons.delete_inactive});
    background-size: 12px 12px;
  }
  :active {
    background: #ff4c4c;
    ::before {
      background: url(${icons.delete_active});
      background-size: 12px 12px;
    }
  }
`;
export const BackButtonStyle = css`
  width: 124px;
  border-color: #999999;
  color: #999999;
  margin: 0 5px;
  :hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
  :active {
    background: #999999;
  }
`;
export const SubmitButtonStyle = css`
  width: 145px;
  margin: 0 5px;
`;
